module.exports = __webpack_public_path__ + "img/soso-2.a3bcb437.jpg";